/**
 * The oldest API version this build is written against.
 *
 * Bump it together with `api-pin.json` whenever this repo starts depending on something newer in
 * the API (a new endpoint, a new field). The API publishes the other direction, the oldest
 * frontend it still supports, at `GET /api/v1/meta/compat`; `useApiCompat` compares both at
 * startup and warns admins on a mismatch.
 */
export const MIN_API_VERSION = '0.14.0';
